import reducer from './reducers'
export { default as actions } from './actions'
export { default as operations } from './operations'
export { default as types } from './types'

export default reducer



// WEBPACK FOOTER //
// ./src/redux/sitesManager/index.js